export default __webpack_public_path__ + "static/media/review.52ab4e6c.svg";